import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Button, Form, Offcanvas } from "react-bootstrap";
import '../../assets/css/Leads.css'
import { Link } from "react-router-dom";
import AddDeliveryBoy from "./AddDeliveryBoy";
import { toast, ToastContainer } from "react-toastify";
import { Tooltip } from "react-tooltip";
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import Select from 'react-select';

const DeliveriesBoys = () => {
  const [leads, setLeads] = useState([]);
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal1, setShowModal1] = useState(false);

  const [showModal3, setShowModal3] = useState(false);
  const [state, setstate] = useState('');


  const [latitude, setlatitude] = useState(null);
  const [longitude, setlongitude] = useState(null);
  const [did, setdid] = useState(null);

  const center = useMemo(() => {
    return {
      lat: parseFloat(latitude),
      lng: parseFloat(longitude),
    };
  }, [latitude, longitude]);

  const [showForm, setShowForm] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedBoy, setSelectedBoy] = useState(null);

  const mapContainerStyle = { width: '100%', height: '350px' };

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyCxtuQLTtr6G4ai6Tz-DiwB-rPKho3iHSs"
  });


  useEffect(() => {
    getLeadsData();
  }, []);

  // Function to get rider location
  const get_rider_location = async (id) => {
    setdid(id);
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    try {
      const response = await axios.get(
        `https://devapi.bykit.in/api/users/get_rider_location/` + id + `??type=live`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data && response.data.data) {
        setlatitude(response.data.data.latitude);
        setlongitude(response.data.data.longitude);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {

    let interval;

    if (showModal1) {
      // Start the interval to call the API every 30 seconds
      interval = setInterval(() => {
        get_rider_location(did); // Fetch the rider location every 30 seconds
      }, 10000); // 30 seconds interval
    } else {
      // Clear the interval if showModal1 is false
      clearInterval(interval);
    }

    // Cleanup interval when the component unmounts or showModal1 changes
    return () => {
      clearInterval(interval);
    };
  }, [showModal1]); // Effect runs when showModal1 changes


  const getLeadsData = async () => {
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    try {
      const response = await axios.get(
        `https://devapi.bykit.in/api/admin/delivery-boys/list?start=${(page - 1) * rowsPerPage}&length=${rowsPerPage}&?type=live`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log('Delivery Boys', response.data)

      if (response.data && response.data.data) {
        setLeads(response.data.data);
        setTotalRows(response.data.recordsTotal || 0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handlePageChange = (newPage) => setPage(newPage);
  const handleRowsPerPageChange = (newRows) => {
    setRowsPerPage(newRows);
    setPage(1);
  };

  const approve = (id) => {
    setShowModal3(true);
    setdid(id);
  };

  const handleToggleStatus = async () => {
    if (!selectedLead) return;
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    const newStatus = selectedLead.is_available === 1 ? 0 : 1;
    const payload = { id: selectedLead.id, is_available: newStatus }

    try {
      const response = await axios.post(
        `https://devapi.bykit.in/api/delivery/update_delivery_boys_available??type=live`, payload,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log('manager account ', response)

      if (response.data?.status) {

        const message = newStatus === 1 ? "Delivery Boy Account activated Successfully" : "Delivery Boy Account not Deactivated Successfully";
        toast.success(message);

        // Update status in state
        getLeadsData();
        setShowModal(false);
      }
    } catch (error) {
      console.error("Error updating status:", error.response?.data || error.message);
    }
  };


  const handleToggleStatus2 = async () => {

    if (!selectedLead) return;
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;
    try {
      const response = await axios.get(
        `https://devapi.bykit.in/api/admin/delete_delivery_boys/${selectedLead.id}??type=live`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log('manager account ', response)

      if (response.data?.status) {
        const newStatus = selectedLead.status === 1 ? 0 : 1;
        const message = "Delivery Boy Account Deleted Successfully";
        toast.success(message);

        // Update status in state
        getLeadsData();
        setShowModal2(false);
      }
    } catch (error) {
      console.error("Error updating status:", error.response?.data || error.message);
    }
  };


  const stateOptions = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
    "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
    "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
    "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
    "Uttar Pradesh", "Uttarakhand", "West Bengal", "Delhi", "Jammu and Kashmir",
    "Ladakh", "Puducherry", "Chandigarh", "Andaman and Nicobar Islands", "Dadra and Nagar Haveli and Daman and Diu",
    "Lakshadweep"
  ].map(state => ({ value: state, label: state }));




  const handleStateChange = selectedOption => {
    setstate(selectedOption?.value || ""); // fallback if cleared
  };


  const handleToggleStatus3 = async () => {
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;
    const payload = { id: did, status: 1 }

    try {
      const response = await axios.post(
        `https://devapi.bykit.in/api/admin/accept_delivery_boys??type=live`, payload,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data?.status) {

        const message = "Delivery Boy Account Successfully Approved";
        toast.success(message);

        // Update status in state
        getLeadsData();
        setShowModal3(false);
      }
    } catch (error) {
      console.error("Error updating status:", error.response?.data || error.message);
    }
  }

  const columns = [
    {
      name: "Created Date",
      cell: (row) => (
        <div>
          <div className="">
            {row.date || "N/A"}<br />
            <span className={`text-white font-bold ${row.status === 0 ? "deactvie_btn" : "active_btn"}`}>
              {row.status === 0 ? "Not Approved" : "Approved"}
            </span><br></br>
          </div>
          {row.status === 0 ? <a style={{ marginTop: "15px", display: "block" }} title="Approve" class="add_workshop_btn me-12" Tooltip="Approve" onClick={() => { approve(row.id) }}><i className="ri-check-fill" style={{ color: "#475569" }}></i></a> : null}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Profile Image",
      cell: (row) => (
        <img
          src={
            row.profile_url && row.profile_url !== 'https://devapi.bykit.in/blank-image.png'
              ? row.profile_url
              : row.profile_image
                ? 'https://devapi.bykit.in/storage/users/' + row.profile_image
                : 'https://via.placeholder.com/50'
          }
          alt="Profile"
          style={{ width: 50, height: 50, objectFit: "cover" }}
        />
      ),
      sortable: false,
    },
    {
      name: "Address Proof",
      cell: (row) => row.address_proof_url ? (
        <img
          src={
            row.address_proof_url && row.address_proof_url !== 'https://devapi.bykit.in/blank-image.png'
              ? row.address_proof_url
              : row.address_proof
                ? 'https://devapi.bykit.in/storage/users/' + row.address_proof
                : 'https://via.placeholder.com/50'
          }
          style={{ width: 50, height: 50, objectFit: "cover" }}
        />
      ) : null,
      sortable: false,
    },

    { name: "Full Name", selector: (row) => row.name || "N/A", sortable: true, },
    { name: "Phone", selector: (row) => row.phone || "N/A", sortable: true, },
    {
      name: "Address", selector: (row) => row.address
        ? `${row.address}${row.city ? " " + row.city : ""}${row.area ? " " + row.area : ""}${row.pincode ? " " + row.pincode : ""}`
        : "N/A", sortable: true,
    },
    { name: "Driving Licence", selector: (row) => row.driving_licence || "N/A", sortable: true, },
    { name: "Aadhaar card", selector: (row) => row.aadhar_card || "N/A", sortable: true, },
    {
      name: "Action",
      cell: (row, index) => (
        <div className="d-flex justify-content-end">
          <div>
            <Tooltip id={`view-tooltip-${row.id}`} place="top" className="tooltip_bg" />
            <button className="edit_btn me-2"
              data-tooltip-id={`edit-tooltip-${row.id}`}
              data-tooltip-content="Edit"
              onClick={() => {
                setSelectedBoy(row);
                setShowForm(true);
              }}>
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--heroicons" width="1em" height="1em" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m16.862 4.487l1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"></path></svg>
            </button>
            <Tooltip id={`edit-tooltip-${row.id}`} place="top" className="tooltip_bg" />
            <button
              className="edit_btn me-2"
              data-tooltip-id={`status-tooltip-${row.id}`}
              data-tooltip-content={row.is_available === 1 ? "Available" : "Unavailable"}
              onClick={() => {
                setSelectedIndex(index);
                setSelectedLead(row); // Store the clicked row
                setShowModal(true);
              }}
            >
              {row.is_available === 1 ? (
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--heroicons" width="1em" height="1em" viewBox="0 0 24 24">
                  <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                    d="M4.5 12.75L9 17.25L19.5 6.75" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    d="M6 6L18 18M6 18L18 6">
                  </path>
                </svg>


              )}
            </button>
            <button
              className="edit_btn me-2"
              data-tooltip-id={`status-tooltip-${row.id}`}
              data-tooltip-content={"Delete"}
              onClick={() => {
                setSelectedIndex(index);
                setSelectedLead(row);
                setShowModal2(true);
              }}>
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--heroicons me-1 ri-close-fill" width="0.8em" height="0.8em" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21q.512.078 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48 48 0 0 0-3.478-.397m-12 .562q.51-.088 1.022-.165m0 0a48 48 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a52 52 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a49 49 0 0 0-7.5 0"></path></svg>
            </button>
            <Tooltip
              id={`status-tooltip-${row.id}`}
              place="top"
              className={row.is_available === 1 ? "tooltip-activate" : "tooltip-deactivate"}
            />
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="container data-table-container p-2">
      <ToastContainer></ToastContainer>
      {!showForm && (
        <div>
          <div className="d-flex align-items-center gap-3">
            <svg className="custom-icon" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="20px" height="20px" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m3 12l2-2m0 0l7-7l7 7M5 10v10a1 1 0 0 0 1 1h3m10-11l2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6"></path>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="18px" height="18px" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m8.25 4.5l7.5 7.5l-7.5 7.5"></path>
            </svg>
            <p className="m-0">Delivery Boys</p>
          </div>
          <div className='managebrand_box mt-3 mb-2 pt-4 pb-1'>
            <div>
              <h4 className='dashboard_head ps-3 pb-4'>Delivery Boys</h4>
            </div>
            <hr></hr>
            <div className="container-fluid mt-3 px-3">
              <div className="row align-items-center gy-2">
                {/* Search + Add Button */}
                <div className="col-12 col-md-7 d-flex flex-column flex-md-row align-items-stretch">
                  <input
                    type="text"
                    placeholder="Search a Delivery Boy by city, state"
                    className="form-control me-md-2 mb-2 mb-md-0 w-100"
                    style={{ padding: '8px', maxWidth: '280px' }}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>

                <div className="col-12 col-md-5 d-flex flex-column flex-md-row align-items-stretch justify-content-md-end">
                  <button
                    className="btn btn-primary w-100  add_workshop_btn"
                    onClick={() => setShowForm(!showForm)}
                    style={{ padding: '8px', maxWidth: '280px' }}
                  >
                    +Add Delivery Boys
                  </button>
                </div>
              </div>



            </div><br />

            <DataTable
              columns={columns}
              data={leads.filter((item) => {
                const searchText = search.toLowerCase();
                const matchesSearch =
                  (item.name && item.name.toLowerCase().includes(searchText)) ||
                  (item.city && item.city.toLowerCase().includes(searchText)) ||
                  (item.address && item.address.toLowerCase().includes(searchText)) ||
                  (item.area && item.area.toLowerCase().includes(searchText)) ||
                  (item.state && item.state.toLowerCase().includes(searchText)) ||
                  (item.pincode && item.pincode.toString().toLowerCase().includes(searchText));

                const matchesState = state === "" || (item.state && item.state.toLowerCase() === state.toLowerCase());

                return matchesSearch && matchesState;
              })}

              pagination
              responsive
              // paginationServer
              //paginationTotalRows={totalRows}
              paginationPerPage={rowsPerPage}
              paginationRowsPerPageOptions={[50, 100, 200, 300, 400]}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handleRowsPerPageChange}
              customStyles={{
                headRow: { style: { backgroundColor: "#E2E8F0", color: "#475569", fontWeight: "bold" } },
                pagination: { style: { borderTop: "1px solid #ddd", padding: "10px", backgroundColor: "#f8f9fa" } },
                cells: {
                  style: {
                    padding: "5px", // Reduces space between columns
                    margin: "0",
                  },
                },
                headCells: {
                  style: {
                    padding: "10px", // Reduces space in header cells
                    margin: "0",
                  },
                },
              }}
            />
          </div>
          <div>
            <Offcanvas className="custom-offcanvas" show={showOffcanvas} onHide={() => setShowOffcanvas(false)} placement="end">
              <Offcanvas.Header closeButton>
                <Offcanvas.Title></Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                {selectedLead && (

                  <div className="lead-details">
                    <div className="row">
                      <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div>
                          <h4 className="detail_title">Date</h4>
                          <p className="detail_text">{selectedLead.date}</p>
                        </div>
                        <div className="mt-4">
                          <h4 className="detail_title">Brand</h4>
                          <div className="d-flex align-items-center">
                            {selectedLead?.brand_logo && (
                              <img
                                src={selectedLead.brand_logo}
                                alt="Brand Logo"
                                style={{ width: 50, height: 50, objectFit: "contain", marginRight: 10 }}
                                onError={(e) => (e.target.style.display = "none")}
                              />
                            )}
                            <span>{selectedLead?.brand_name || "-"}</span>
                          </div>
                        </div>

                        <div className="mt-4">
                          <h4 className="detail_title">Total Amount</h4>
                          <p className="detail_text">{selectedLead.total_amount || "-"}</p>
                        </div>

                        <div className="mt-4">
                          <h4 className="detail_title">Insurance Number</h4>
                          <p className="detail_text"> {selectedLead.insurance_number || "-"}</p>
                        </div>

                        <div className="mt-4">
                          <h4 className="detail_title">Message</h4>
                          <p className="detail_text">{selectedLead.message || "-"}</p>

                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div>
                          <h4 className="detail_title">Service Type</h4>
                          <p className="detail_text">
                            {selectedLead.service_type === 0
                              ? `Free / ${selectedLead.free_service_no} Free Service`
                              : 'Paid'}
                          </p>
                        </div>
                        <div className="mt-4">
                          <h4 className="detail_title">Model</h4>
                          <p className="detail_text"> {selectedLead.model || "-"}</p>
                        </div>
                        {
                          selectedLead.payment_status != -1 ?
                            <div className="mt-4">
                              <h4 className="detail_title">Payment Status</h4>
                              <p className="detail_text">{selectedLead.payment_status === 1 ? "Paid" : "Unpaid"}</p>
                            </div>
                            : null
                        }

                        <div className="mt-4">
                          <h4 className="detail_title">Insurance Expiry Date</h4>
                          <p className="detail_text">{selectedLead.insurance_expiry || "-"}</p>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div>
                          <h4 className="detail_title">Customer Name</h4>
                          <p className="detail_text">{selectedLead.customer_name}</p>
                        </div>
                        <div className="mt-4">
                          <h4 className="detail_title">Pickup/Drop</h4>
                          <div className="mt-2">
                            <span className="btn droppickup_btn btn-sm">
                              {selectedLead?.pickup_drop_facility === 0
                                ? "Pickup"
                                : selectedLead?.pickup_drop_facility === 3
                                  ? "Self Pickup/Drop"
                                  : selectedLead?.pickup_drop_facility === 1
                                    ? "Drop"
                                    : "Pickup & Drop"}
                            </span>
                          </div>
                        </div>

                        <div className="mt-4">
                          <h4 className="detail_title">Payment Method</h4>
                          <p className="detail_text">{selectedLead.payment_method || "-"}</p>
                        </div>

                        <div className="mt-4">
                          <h4 className="detail_title">View Insurance Copy</h4>
                          <Link to={selectedLead.insurance_copy} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>View Attachment</Link>
                        </div>

                      </div>


                      <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div>
                          <h4 className="detail_title">Vehicle Number:</h4>
                          <p className="detail_text">{selectedLead.vehicle_name}</p>
                        </div>
                        <div className="mt-4">
                          <h4 className="detail_title">Status</h4>
                          <button className="btn droppickup_btn mt-1">
                            {

                              selectedLead.status === 7
                                ? "Service Started"
                                : selectedLead.status === 6
                                  ? "Approved"
                                  : selectedLead.status === 2
                                    ? "Assigned (Delivery)"
                                    : selectedLead.status === 1 ? "Convered"
                                      : selectedLead.status === 3 ? "Pickup From User Location"
                                        : selectedLead.status === 4 ? "Drop To Workshop"
                                          : selectedLead.status === 5 ? "Quote Send By Manage"
                                            : selectedLead.status === 6 ? "Approved By Client"
                                              : selectedLead.status === 7 ? "Service Start"
                                                : selectedLead.status === 8 ? "Service Completed"
                                                  : selectedLead.status === 9 ? "Payment Completed"
                                                    : selectedLead.status === 10 ? "Pickup From Workshop"
                                                      : selectedLead.status === 11 ? "Completed/delivered By Delivery Boy"
                                                        : selectedLead.status === 12 ? "Quote Rejected By User"
                                                          : selectedLead.status === 13 ? "Cancelled"
                                                            : selectedLead.status === 14 ? "Estimation Added"
                                                              : selectedLead.status === 0 ? "Pending"
                                                                : selectedLead.status === 16 ? "Case Closed"
                                                                  : 'N/a'
                            }
                          </button>
                        </div>

                        <div className="mt-4">
                          <h4 className="detail_title">Insurance Company</h4>
                          <p className="detail_text"> {selectedLead.insurance_company || "-"}</p>
                        </div>
                        <div className="mt-4">
                          <h4 className="detail_title">View RC Book:</h4>
                          <Link to={selectedLead.rc_book} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>View Attachment</Link>
                        </div>
                      </div>
                    </div>

                  </div>
                )}
              </Offcanvas.Body>
            </Offcanvas>
          </div>
        </div>
      )}
      {/* Modal */}
      {showModal && (
        <div className="modal-overlay delete-overlay">
          <div className="modal-content delete-content">
            <div className="modal-header bg-dark text-white mt-0">
              <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
            </div>
            <div className='p-3'>
              <p className="delete_text">
                Are you sure you want to change the Availability Status?
              </p>
            </div>
            <hr className='p-0 m-0'></hr>
            <div className="modal-buttons text-end p-3">
              <button onClick={() => setShowModal(false)} className='model_dlt_btn me-3'>No</button>
              <button onClick={handleToggleStatus} className='model_dlt_btn'>Yes</button>
            </div>
          </div>
        </div>
      )}


      {showModal2 && (
        <div className="modal-overlay delete-overlay">
          <div className="modal-content delete-content">
            <div className="modal-header bg-dark text-white mt-0">
              <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal2(false)}></button>
            </div>
            <div className='p-3'>
              <p className="delete_text">
                Are you sure you want to delete this account?
              </p>
            </div>
            <hr className='p-0 m-0'></hr>
            <div className="modal-buttons text-end p-3">
              <button onClick={() => setShowModal2(false)} className='model_dlt_btn me-3'>No</button>
              <button onClick={handleToggleStatus2} className='model_dlt_btn'>Yes</button>
            </div>
          </div>
        </div>
      )}


      {showModal3 && (
        <div className="modal-overlay delete-overlay">
          <div className="modal-content delete-content">
            <div className="modal-header bg-dark text-white mt-0">
              <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal3(false)}></button>
            </div>
            <div className='p-3'>
              <p className="delete_text">
                Are you sure you want to approve this account?
              </p>
            </div>
            <hr className='p-0 m-0'></hr>
            <div className="modal-buttons text-end p-3">
              <button onClick={() => setShowModal3(false)} className='model_dlt_btn me-3'>No</button>
              <button onClick={handleToggleStatus3} className='model_dlt_btn'>Yes</button>
            </div>
          </div>
        </div>
      )}



      {showModal1 && (
        <div className="modal-overlay delete-overlay">
          <div className="modal-content delete-content">
            <div className="modal-header bg-dark text-white mt-0">
              <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal1(false)}></button>
            </div>
            <div className='p-3'>
              {isLoaded && latitude ? (
                <GoogleMap
                  mapContainerStyle={mapContainerStyle}
                  center={center}
                  zoom={18}
                >
                  <Marker position={center} />
                </GoogleMap>
              ) : (
                <p>Loading Map...</p>
              )}
            </div>
            <hr className='p-0 m-0'></hr>
          </div>
        </div>
      )}

      {showForm && <AddDeliveryBoy setShowForm={setShowForm} refreshManagers={getLeadsData} selectedBoy={selectedBoy} />}
    </div>
  );
};
export default DeliveriesBoys;